import React from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import {
  ConfirmationNumber as TicketIcon,
  Person as PersonIcon,
  AttachMoney as MoneyIcon,
} from "@mui/icons-material";
import SummaryCard from "../SummaryCard";
import { formatCurrency } from "../../utils/formatters";
import { GRADIENTS } from "../../utils/gradients";

const RevenueStatistics = ({ dashboardData }) => {
  if (!dashboardData) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
        Brak danych do wyświetlenia
      </Typography>
    );
  }

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={4}>
          <SummaryCard
            icon={<MoneyIcon />}
            label="Całkowity przychód"
            value={formatCurrency(dashboardData.total_revenue)}
            gradient={GRADIENTS.purple}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <SummaryCard
            icon={<TicketIcon />}
            label="Sprzedane karnety"
            value={dashboardData.pass_statistics.count}
            caption={formatCurrency(dashboardData.pass_statistics.total_revenue)}
            gradient={GRADIENTS.blue}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <SummaryCard
            icon={<PersonIcon />}
            label="Wejścia jednorazowe"
            value={dashboardData.single_entry_statistics.count}
            caption={formatCurrency(dashboardData.single_entry_statistics.total_revenue)}
            gradient={GRADIENTS.orange}
          />
        </Grid>
      </Grid>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
          Podział przychodów
        </Typography>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6}>
            <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Przychód z karnetów
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 600, color: '#4facfe' }}>
                {formatCurrency(dashboardData.pass_statistics.total_revenue)}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {dashboardData.total_revenue > 0
                  ? `${((dashboardData.pass_statistics.total_revenue / dashboardData.total_revenue) * 100).toFixed(1)}% całkowitego przychodu`
                  : '0% całkowitego przychodu'}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Przychód z wejść jednorazowych
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 600, color: '#fa709a' }}>
                {formatCurrency(dashboardData.single_entry_statistics.total_revenue)}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {dashboardData.total_revenue > 0
                  ? `${((dashboardData.single_entry_statistics.total_revenue / dashboardData.total_revenue) * 100).toFixed(1)}% całkowitego przychodu`
                  : '0% całkowitego przychodu'}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default RevenueStatistics;
